import React from 'react';
import CompassLogo from './CompassLogo';
import FooterLogo from './FooterLogo';
import HealthScoreCard from './HealthScoreCard';
import HealthScale from './HealthScale';
import HealthSummary from './HealthSummary';
import RiskList from './RiskList';
import styles from './HealthOverview.module.css';

interface StatData {
  label: string;
  value: number;
  unit?: string;
  icon?: React.ReactNode;
  status?: 'good' | 'fair' | 'attention' | 'monitor';
}

interface RiskData {
  label: string;
  value: number;
  status: 'low' | 'medium' | 'high';
  description?: string;
}

interface HealthOverviewPageProps {
  patientName: string;
  score: number;
  doctorNote: string;
  stats: StatData[];
  risks: RiskData[];
}

const HealthOverviewPage: React.FC<HealthOverviewPageProps> = ({
  patientName,
  score,
  doctorNote,
  stats,
  risks
}) => {
  return (
    <div className={styles.healthOverviewContainer}>
      {/* Background Image */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '596px',
        height: '842px',
        backgroundImage: 'url(/path/to/background-image.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        zIndex: -1
      }} />

      {/* Header with Compass Logo */}
      <div style={{
        position: 'absolute',
        top: '47px',
        right: '45px',
        display: 'flex',
        alignItems: 'center',
        gap: '20px'
      }}>
        <CompassLogo width={104} height={29} />
      </div>

      {/* Green Accent Bar */}
      <div style={{
        position: 'absolute',
        top: '120px',
        left: 0,
        width: '596px',
        height: '4px',
        backgroundColor: '#28A049'
      }} />

      {/* Main Title */}
      <div style={{
        position: 'absolute',
        top: '142px',
        left: '176px',
        width: '244px',
        height: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <h1 style={{
          fontFamily: 'BT Beau Sans, sans-serif',
          fontWeight: 800,
          fontSize: '20px',
          lineHeight: '30px',
          textAlign: 'center',
          color: '#007BC2',
          margin: 0
        }}>
          TỔNG QUAN SỨC KHỎE
        </h1>
      </div>

      {/* Main Content Area */}
      <div style={{
        position: 'absolute',
        top: '190px',
        left: '45px',
        display: 'flex',
        alignItems: 'center',
        gap: '20px'
      }}>
        {/* Circular Health Score */}
        <div style={{
          width: '243px',
          height: '206px',
          backgroundColor: '#FFFFFF',
          borderRadius: '10px',
          boxShadow: '0px 0px 6px 0px rgba(14, 124, 193, 0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <HealthScale score={score} size={160} />
        </div>

        {/* Patient Info Cards */}
        <HealthScoreCard
          patientName={patientName}
          score={score}
          doctorNote={doctorNote}
        />
      </div>

      {/* Health Summary Section */}
      <div style={{
        position: 'absolute',
        top: '426px',
        left: '45px',
        width: '505px'
      }}>
        <HealthSummary stats={stats} />
      </div>

      {/* Risk Assessment Section */}
      <div style={{
        position: 'absolute',
        top: '556px',
        left: '45px',
        width: '505px'
      }}>
        <RiskList risks={risks} />
      </div>

      {/* Footer */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '595px',
        height: '79px',
        backgroundColor: '#FFFFFF'
      }}>
        {/* Footer gradient */}
        <div style={{
          position: 'absolute',
          bottom: '19.63px',
          left: 0,
          width: '312.38px',
          height: '19.59px',
          background: 'linear-gradient(90deg, rgba(9, 125, 189, 1) 0%, rgba(40, 155, 72, 0) 100%)'
        }} />

        {/* Footer Logo */}
        <div style={{
          position: 'absolute',
          bottom: 0,
          right: 0,
          width: '78.95px',
          height: '79px'
        }}>
          <FooterLogo width={78.95} height={79} />
        </div>
      </div>
    </div>
  );
};

export default HealthOverviewPage;
